"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _package = _interopRequireDefault({ version: '3.26.20' });

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _package["default"].version;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/version/index.js
// module id = 953
// module chunks = 1